import Entity from "entity";
import { ValidatorHelper } from "functions";

import { Cookies } from "react-cookie"

export default class Fazenda extends Entity {
    static get collectionUID() {
        return "Fazenda";
    }
    async initialize() {
        this.data.status = "ATIVO";
    }

    static get getInitialValues() {
        return { status: "ATIVO" }
    }
    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO").orderBy("nome");
    }

    static get labelField() {
        return "nome";
    }

    static get searchColumns() {
        return [
            { field: "nome", headerName: "Nome", flex: 2, filter: true },
        ];
    }

    static async validFieldErrors(values) {
        let v = new ValidatorHelper();

        v.addRequired("nome", "Nome da Fazenda")

        let errorsMessage = v.valid(values);

        if (errorsMessage.length) {
            return errorsMessage
        }

        const cookies = new Cookies()
        const entity = await Fazenda.get(values.uid)

        if(entity && values.uid === entity.data.uid) {
            return null
        }

        if (cookies.get("fazendas").find(f => values.nome.toUpperCase() === f)) {
            return ["Fazenda já cadastrada"]
        }

        return null
    }
}
